<template>
<div class="layer-project" data-project-name="lotte-group"><!-- Project Name -->
    <div class="layer-project-detail">
        <!-- Page Contents -->
        <section class="project-visual">
            <div>
                <h1 class="project-tit">Lotte Group</h1>
                <a href="http://www.lotte.co.kr" class="link" target="_blank">www.lotte.co.kr</a>
            </div>
        </section>
        <!-- Details [s] -->
        <section class="project-overview">
            <div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">롯데그룹의 이미지와 정보를 모바일에 최적화하고 최신 트렌드가 반영된 디자인으로 변경하기 위한 니즈를 반영한 프로젝트입니다. 롯데그룹의 아이덴티티를 표현하기 위해 메뉴별로 컬러를 구성하여 다양한 롯데의 모습을 표현하였고, 메인 비주얼을 메뉴별로 구성하고 세로 슬라이딩 방식의 인터랙션을 활용하여 하나로 연결되는 느낌을 줄 수 있도록 구성했습니다.</p>
                <div class="project-overview-diagram">
                    <p class="diagram01">
                        <ul>
                            <li class="item01">Brand Identity</li>
                            <li class="item02">UI/UX Design</li>
                            <li class="item03">LOTTE World Tower</li>
                        </ul>
                    </p>
                    <p class="diagram02">LOTTE GROUP<br>Identity</p>
                </div>
            </div>
        </section>
        <!-- Details [e] -->

        <section class="section full section01">
            <div class="inner-section">
                <div class="information-area">
                    <strong class="project-subtit">Mobile Web</strong>
                    <p class="sub-text">풀스크린으로 롯데의 다양한 계열사의 이미지를 통해 글로벌 프리미엄 브랜드임을 시각적으로 표현하고, LNB는 UI/UX 디자인에 브랜드 컬러를 활용하여 롯데그룹의 브랜드 컬러와 아이덴티티를 한눈에 보이도록 하였습니다.</p>
                </div>
                <div class="img">
                    <img src="" alt="" data-src="/static/img/project-detail/lotte-group/mobile-web-01-img@m.png">
                </div>
            </div>
        </section>
        
        <section class="section full section02">
            <div class="inner-section">
                <div class="information-area">
                    <p class="sub-text">아시아를 선도하는 글로벌기업으로서 고급스러움을 <br><span class="ib">톤다운된 컬러로 표현하였으며,</span> 모바일 특성에 맞는 <span class="ib">콘텐츠 디자인으로</span><br> 편리하게 이용할 수 있도록 작업했습니다.</p>
                </div>
                <div class="img">
                    <img src="" alt="" data-src="/static/img/project-detail/lotte-group/mobile-web-02-img@m.png">
                </div>
            </div>
        </section>
        
        <section class="section full section03">
            <div class="inner-section">
                <div class="information-area">
                    <strong class="project-subtit">Layout</strong>
                    <p class="sub-text">브랜드 컬러를 사용한 상단의 내비게이션은 <span class="ib">각 페이지로</span> 이동이 자유로운 UI/UX디자인으로, 모바일에 최적화된 레이아웃으로 작업하였습니다.</p>
                </div>
                <div class="img">
                    <img src="" alt="" data-src="/static/img/project-detail/lotte-group/layout-img@m.png">
                </div>
            </div>
        </section>

        <section class="section full section04">
            <div class="inner-section">
                <div class="point-icon-area">
                    <ul>
                        <li class="item01">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon01@m.png">
                            </div>
                        </li>
                        <li class="item02">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon02@m.png">
                            </div>
                        </li>
                        <li class="item03">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon03@m.png">
                            </div>
                        </li>
                        <li class="item04">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon04@m.png">
                            </div>
                        </li>
                        <li class="item05">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon05@m.png">
                            </div>
                        </li>
                        <li class="item06">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon06@m.png">
                            </div>
                        </li>
                        <li class="item07">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon07@m.png">
                            </div>
                        </li>
                        <li class="item08">
                            <div class="img">
                                <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-icon08@m.png">
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="point-color-area">
                    <ul>
                        <li class="item01">
                            <strong>Main</strong>
                            <p>#b31619</p>
                        </li>
                        <li class="item02">
                            <strong>Sub</strong>
                            <p>#94744d</p>
                        </li>
                        <li class="item03">
                            <strong>Sub</strong>
                            <p>#333333</p>
                        </li>
                        <li class="item04">
                            <strong>Sub</strong>
                            <p>#707783</p>
                        </li>
                    </ul>
                </div>
                <div class="point-font-area clfix">
                    <div class="point-font-title">
                        <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-font-title@m.png">
                    </div>
                    <div class="point-font-text">
                        <img src="" alt="" data-src="/static/img/project-detail/lotte-group/point-font-text@m.png">
                    </div>
                </div> 
            </div>
        </section>

        <section class="project-client"><strong class="a11y-hidden">LOTTE GROUP</strong></section>
        <!-- Page Contents -->
    </div>

    
    <app-pjmove></app-pjmove>
</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.sub-text {
	word-break: keep-all;
}
.project-tit {
	text-transform: uppercase;
}
.project-subtit {
	display: block;
	margin-bottom: 10px;
	font-size: 2rem;
}
.sub-text {
	line-height: 1.5;
	font-weight: 500;
}
.information-area {
	padding: 0 15px;
}
@media screen and (max-width: 711px) {
	.section01 .inner-section,
	.section02 .inner-section,
	.section03 .inner-section {
		display: flex;
		flex-wrap: wrap-reverse;
	}
}
@media screen and (min-width: 712px) {
	.project-subtit {
		font-size: 3.3rem;
	}
	.information-area {
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.project-subtit {
		font-size: 56px;
	}
	.sub-text {
		font-size: 15px;
		line-height: 28px;
		font-weight: 400;
	}
	.information-area {
		padding: 0;
	}
	.inner-section {
		max-width: 1280px;
		margin: 0 auto;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/lotte-group/ci.png) 50% / auto
		87.5px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-group/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-group/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 106px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-group/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 212px;
	}
}

/* Overview */
.project-overview-txt {
	margin-bottom: 30px;
}
.project-overview {
	background-color: #ba272d;
	color: #fff;
}
.project-overview-diagram {
	line-height: 1.2;
	text-align: center;
}
.project-overview-diagram .diagram01 ul {
	display: flex;
	align-items: center;
	justify-content: center;
}
.project-overview-diagram .diagram01 li {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100px;
	height: 100px;
	padding: 10px;
	border: 1px solid #fff;
	border-radius: 50%;
}
.project-overview-diagram .diagram01 li + li {
	margin-left: -6px;
}
.project-overview-diagram .diagram01 .item03 {
	padding: 8px;
}
.project-overview-diagram .diagram02 {
	position: relative;
	width: 100px;
	height: 100px;
	margin: 70px auto 0;
	padding-top: 35px;
	color: #ba272d;
	background-color: #fff;
	border-radius: 50%;
}
.project-overview-diagram .diagram02:before {
	content: "";
	position: absolute;
	top: -55px;
	left: 50%;
	width: 1px;
	height: 40px;
	background-color: #fff;
}
@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 20px;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: space-between;
		max-width: 632px;
		margin: 0 auto;
		line-height: 17px;
		font-weight: 500;
	}
	.project-overview-diagram .diagram01 li {
		width: 132px;
		height: 132px;
	}
	.project-overview-diagram .diagram01 .item01 {
		padding: 25px;
	}
	.project-overview-diagram .diagram02 {
		width: 132px;
		height: 132px;
		margin: 0;
		padding-top: 50px;
	}
	.project-overview-diagram .diagram02:before {
		width: 87px;
		height: 1px;
		top: 50%;
		left: -97px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding: 20px 20px 10px;
	}
	.project-overview-tit {
		font-size: 36px;
	}
	.project-overview-txt {
		margin-bottom: 55px;
		font-size: 15px;
		line-height: 28px;
	}
	.project-overview-diagram {
		max-width: 1280px;
		font-size: 20px;
		line-height: 26px;
	}
	.project-overview-diagram .diagram01 li {
		width: 246px;
		height: 246px;
	}
	.project-overview-diagram .diagram01 .item01,
	.project-overview-diagram .diagram01 .item03 {
		padding: 60px;
	}
	.project-overview-diagram .diagram02 {
		width: 246px;
		height: 246px;
		padding-top: 100px;
		font-size: 28px;
		line-height: 30px;
	}
	.project-overview-diagram .diagram02:before {
		width: 162px;
		height: 2px;
		top: 50%;
		left: -220px;
	}
}

.section01 {
	background: url(/static/img/project-detail/lotte-group/mobile-web-01-bg@m.png)
		100% -10px no-repeat;
	background-size: 48.28125vw auto;
}
@media screen and (max-width: 711px) {
	.layer-project-detail > section.section01 {
		padding-top: 0;
	}
	.section01 .information-area {
		margin-top: -30px;
	}
}
@media screen and (min-width: 712px) {
	.layer-project-detail > section.section01 {
		padding-bottom: 0;
	}
	.section01 {
		background-image: url(/static/img/project-detail/lotte-group/mobile-web-01-bg@t.png);
		background-position-y: -5.19vw;
		background-size: 42.3455vw auto;
	}
	.section01 .inner-section {
		display: flex;
		padding-top: 60px;
	}
	.section01 .information-area {
		padding-left: 40px;
		padding-right: 60px;
		width: 50%;
	}
	.section01 .img {
		width: 50%;
	}
}
@media screen and (min-width: 1280px) {
	.section01 {
		background-image: url(/static/img/project-detail/lotte-group/mobile-web-01-bg@w.png);
		background-position-x: calc(50% + 470.5px);
		background-position-y: -212px;
		background-size: 979px auto;
	}
	.section01 .inner-section {
		position: relative;
		display: block;
		max-width: 1440px;
		padding-top: 230px;
	}
	.section01 .inner-section:after {
		content: "";
		display: block;
		clear: both;
	}
	.section01 .information-area {
		position: absolute;
		top: 240px;
		left: 20px;
		width: 400px;
		padding-left: 0;
	}
	.section01 .img {
		float: right;
		width: 1026px;
	}
}

.section02 {
	background: url(/static/img/project-detail/lotte-group/mobile-web-02-bg@m.png)
		0 0 no-repeat;
	background-size: 36.875vw auto;
}
@media screen and (min-width: 712px) {
	.layer-project-detail > section.section02 {
		padding-top: 0;
	}
	.section02 {
		background-image: url(/static/img/project-detail/lotte-group/mobile-web-02-bg@t.png);
		background-size: 33.778vw auto;
	}
	.section02 .information-area {
		margin-bottom: 50px;
		padding-left: 38.62vw;
		padding-right: 14.46vw;
	}
	.section02 .img {
		padding-left: 25px;
	}
	.section02 .img img {
		width: 74.29775vw;
	}
}
@media screen and (min-width: 1280px) {
	.section02 {
		background-image: url(/static/img/project-detail/lotte-group/mobile-web-02-bg@w.png);
		background-position-x: calc(50% - 468.5px);
		background-size: 785px auto;
	}
	.section02 .inner-section {
		padding-top: 110px;
	}
	.section02 .information-area {
		padding-left: 50%;
		padding-right: 200px;
	}
	.section02 .img img {
		width: auto;
	}
}

.layer-project-detail > section.section03 {
	padding-top: 0;
}
@media screen and (min-width: 712px) {
	.layer-project-detail > section.section03 {
		padding-bottom: 0;
	}
	.section03 .inner-section {
		position: relative;
		padding-top: 65px;
	}
	.section03 .information-area {
		position: absolute;
		top: 0;
		left: 0;
		width: 50%;
	}
	.section03 .img {
		text-align: right;
		padding-right: 40px;
	}
	.section03 .img img {
		width: 60.2528vw;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .inner-section {
		max-width: 1440px;
		padding-top: 100px;
		padding-left: 100px;
		padding-bottom: 150px;
	}
	.section03 .information-area {
		top: 95px;
		left: 100px;
		width: 310px;
	}
	.section03 .img img {
		width: auto;
	}
}

.section04 {
	position: relative;
	background-color: #ededed;
}
.section04:after {
	content: "";
	position: absolute;
	top: -20px;
	left: 50%;
	width: 1px;
	height: 40px;
	background-color: #cbcbcb;
}
.point-icon-area {
	padding-left: 15px;
}
.point-icon-area ul {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
}
.point-icon-area ul li {
	width: 25%;
}
.point-icon-area ul li img {
	vertical-align: middle;
}
.point-icon-area ul .item01 img {
	width: 49px;
}
.point-icon-area ul .item02 img {
	width: 59px;
}
.point-icon-area ul .item03 img {
	width: 51.5px;
}
.point-icon-area ul .item04 img {
	width: 62px;
}
.point-icon-area ul .item05 img {
	width: 56.5px;
}
.point-icon-area ul .item06 img {
	width: 45px;
}
.point-icon-area ul .item07 img {
	width: 48.5px;
}
.point-icon-area ul .item08 img {
	width: 57.5px;
}
.point-color-area {
	margin-bottom: 20px;
}
.point-color-area ul {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}
.point-color-area ul li {
	position: relative;
	width: calc(50% - 5.5px);
	max-width: 134px;
	height: 62px;
	margin: 0 11px 20px;
	padding-top: 13px;
	padding-left: 72px;
	background-color: #fff;
	font-size: 12px;
	box-shadow: 0 8px 13.5px rgba(0, 0, 0, 0.26);
}
.point-color-area ul li:before {
	content: "";
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	width: 63px;
	height: 62px;
}
.point-color-area ul .item01:before {
	background-color: #b31619;
}
.point-color-area ul .item02:before {
	background-color: #94744d;
}
.point-color-area ul .item03:before {
	background-color: #333;
}
.point-color-area ul .item04:before {
	background-color: #707783;
}
.point-color-area ul li strong {
	display: block;
	color: #707070;
	font-weight: 600;
	letter-spacing: 0.2em;
	text-transform: uppercase;
}
.point-font-area {
	padding: 0 15px;
}
@media screen and (max-width: 711px) {
	.point-icon-area,
	.point-font-area {
		max-width: 320px;
		margin: 0 auto;
	}
	.point-icon-area {
		margin-bottom: 20px;
	}
	.point-font-title {
		margin-bottom: 20px;
	}
	.point-font-title img {
		width: 147.5px;
	}
	.point-font-text img {
		width: 257.5px;
	}
}
@media screen and (min-width: 712px) {
	.section04 .inner-section {
		padding-top: 60px;
		padding-bottom: 20px;
	}
	.section04:after {
		top: -40px;
		height: 80px;
	}
	.point-icon-area {
		margin-bottom: 20px;
		padding-left: 0;
	}
	.point-icon-area ul {
		max-width: 712px;
		margin: 0 auto;
	}
	.point-icon-area ul li .img {
		text-align: center;
	}
	.point-icon-area ul .item01,
	.point-icon-area ul .item05 {
		padding-left: 40px;
	}
	.point-icon-area ul .item04,
	.point-icon-area ul .item08 {
		padding-right: 30px;
	}
	.point-icon-area ul .item01 .img,
	.point-icon-area ul .item05 .img {
		text-align: left;
	}
	.point-icon-area ul .item04 .img,
	.point-icon-area ul .item08 .img {
		text-align: right;
	}
	.point-icon-area ul .item01 img {
		width: 63.5px;
	}
	.point-icon-area ul .item02 img {
		width: 76.5px;
	}
	.point-icon-area ul .item03 img {
		width: 67px;
	}
	.point-icon-area ul .item04 img {
		width: 76.5px;
	}
	.point-icon-area ul .item05 img {
		width: 73px;
	}
	.point-icon-area ul .item06 img {
		width: 58px;
	}
	.point-icon-area ul .item07 img {
		width: 62.5px;
	}
	.point-icon-area ul .item08 img {
		width: 71px;
	}
	.point-color-area ul li {
		max-width: 139px;
		margin: 0 13px 40px;
	}
	.point-font-area {
		max-width: 712px;
		margin: 0 auto;
		padding: 0 40px;
	}
	.point-font-area .point-font-title {
		float: left;
	}
	.point-font-area .point-font-text {
		float: right;
	}
	.point-font-title img {
		width: 221px;
	}
	.point-font-text img {
		width: 321.5px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		max-width: 1300px;
		padding: 0;
		padding-top: 145px;
		padding-bottom: 120px;
	}
	.section04:after {
		top: -100px;
		width: 2px;
		height: 200px;
	}
	.point-icon-area {
		margin-bottom: 60px;
	}
	.point-icon-area ul {
		max-width: none;
	}
	.point-icon-area ul .item01,
	.point-icon-area ul .item05 {
		padding-left: 30px;
		text-align: left;
	}
	.point-icon-area ul .item04,
	.point-icon-area ul .item08 {
		padding-right: 0;
		text-align: right;
	}
	.point-icon-area ul .item01 img {
		width: 127px;
	}
	.point-icon-area ul .item02 img {
		width: 103px;
	}
	.point-icon-area ul .item03 img {
		width: 134px;
	}
	.point-icon-area ul .item04 img {
		width: 153px;
	}
	.point-icon-area ul .item05 img {
		width: 146px;
	}
	.point-icon-area ul .item06 img {
		width: 116px;
	}
	.point-icon-area ul .item07 img {
		width: 125px;
	}
	.point-icon-area ul .item08 img {
		width: 142px;
	}
	.point-color-area ul li {
		max-width: 242px;
		height: 121px;
		margin: 0 45px 90px;
		padding-top: 40px;
		padding-left: 140px;
		font-size: 15px;
	}
	.point-color-area ul li:before {
		width: 121px;
		height: 121px;
	}
	.point-color-area ul .item01 {
		margin-left: 20px;
	}
	.point-color-area ul .item04 {
		margin-right: 20px;
	}
	.point-color-area ul li strong {
		font-size: 14px;
	}
	.point-font-area {
		max-width: none;
		padding: 0 30px;
	}
	.point-font-title img {
		width: auto;
	}
	.point-font-text img {
		width: auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/lotte-group.vue